import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from 'Common/Components/Checkbox';
import styled from 'styled-components';
import { selectAllAgents, selectRow, getUserAgent, unSelectAll } from 'store/Agents/actions';
import { allAgentsAreSelected, selectAgentsSelected, someAgentIsSelected } from 'store/Agents/selectors';
import get from 'lodash/get';
import { NameWrapper, Name, Categories } from '../styled';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';

const CheckHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CheckHeader = ({ disabled }) => {
  const allAgentsSelected = useSelector(allAgentsAreSelected);
  const someAgentSelected = useSelector(someAgentIsSelected);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(selectAllAgents());
  };

  return (
      <CheckHeaderContainer title="Select">
        <Checkbox disabled={ disabled } theme="grey" onChange={ handleClick } state={ allAgentsSelected } partialChecked={ someAgentSelected && !allAgentsSelected } />
      </CheckHeaderContainer>
  );
};

export const CheckColum = ({ agent, disabled }) => {
  const agentsSelected = useSelector((state) => selectAgentsSelected(state));
  const dispatch = useDispatch();
  const isSelected = agentsSelected.find((agentSelected) => agentSelected.id === agent.id);
  const handleClick = (e) => {
    // dispatch(unSelectAll());
    dispatch(selectRow(e, agent));
  };
  return (
      <div title="Select">
        <Checkbox disabled={ disabled } theme="grey" state={ !!isSelected } onChange={ handleClick } />
      </div>
  );
};

export const NameCell = ({ agent }) => {
  const dispatch = useDispatch();
  const id = get(agent, 'id', 0);
  const name = get(agent, 'name', '');

  const handleClick = (e) => {
    dispatch(unSelectAll());
    dispatch(selectRow(e, agent));
    dispatch(getUserAgent(id));
    dispatch(openModal(MODAL_AGENT_DETAIL));
  };

  return (
    <NameWrapper>
      <Name onClick={ handleClick } >{ name }</Name>
    </NameWrapper>
  );
};

export const CategoriesCell = ({ agent }) => {
  const tools = get(agent, 'executors', []);
  const categories = [...new Set(tools.flatMap(el => el.category || []).filter(c => c !== null))];
  const parsedCategories = categories?.join(', ');

  return (
    <Categories title={ parsedCategories }>{ parsedCategories }</Categories>
  );
};
